import { Text, Title } from "@mantine/core"
import { Card } from "@tfg/ui"
import { Trans, useTranslation } from "react-i18next"

import { CertificateByOrganizationDto } from "~/gen/api"
import { formatDate } from "~/utils/date"

export type ProcessedCertificateDescriptionProps = {
  certificate: CertificateByOrganizationDto
}

export const ProcessedCertificateDescription = ({
  certificate,
}: ProcessedCertificateDescriptionProps) => {
  const { t } = useTranslation("certificates")

  const isCertificateBounded = certificate.issueDate && certificate.expiryDate

  const descriptionValues = {
    type: certificate.type.name,
    issueDate: certificate.issueDate ? formatDate(certificate.issueDate) : "",
    expiryDate: certificate.expiryDate
      ? formatDate(certificate.expiryDate)
      : "",
    productionSiteName: certificate.productionSite.name,
    productionSiteOrganizationName:
      certificate.productionSite.createdBy.organization.name,
    activityName: certificate.processingSteps.join(", "),
  }

  const descriptionComponents = {
    b: <span style={{ fontWeight: "600" }} />,
    activityName: <span />,
  }

  return (
    <Card h="fit-content" mih="fit-content" my="xs">
      <Card.Section>
        <Title order={3}>{t("modal.form.summary")}</Title>
      </Card.Section>
      <Card.Section>
        <Text>
          {isCertificateBounded ? (
            <Trans
              ns="certificates"
              i18nKey="modal.form.description.bounded"
              components={descriptionComponents}
              values={descriptionValues}
            />
          ) : (
            <Trans
              ns="certificates"
              i18nKey="modal.form.description.open"
              components={descriptionComponents}
              values={descriptionValues}
            />
          )}
        </Text>
      </Card.Section>
    </Card>
  )
}
